module.exports = __webpack_public_path__ + "static/media/pic-1.97e5709b.jpg";